import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { getCaseBySlug } from "../data/cases";
import { PRODUCTS } from "../data/products";
import { CtaForm } from "../components/CtaForm";

export default function CaseDetail() {
  const { slug } = useParams();
  const c = getCaseBySlug(slug);
  if (!c) return <Navigate to="/cases" replace />;

  const relatedProducts = PRODUCTS.filter((p) => c.products.includes(p.slug));

  return (
    <>
      <section className="detail-hero">
        <div className="container">
          <div className="detail-hero-inner">
            <Link to="/cases" className="detail-back" data-testid="case-back-link">
              <ChevronLeft size={14} /> All case studies
            </Link>
            <div className="section-label"><span className="dot" />{c.industry}</div>
            <h1 className="detail-hero-title" data-testid="case-detail-h1">
              {c.client} — <em>{c.label}</em>
            </h1>
            <p style={{ fontSize: 18, color: "var(--text-2)", maxWidth: 760, lineHeight: 1.6 }}>
              {c.overview}
            </p>
            <div className="detail-hero-metric" data-testid="case-headline-metric">
              <div className="detail-hero-metric-value">{c.metric}</div>
              <div className="detail-hero-metric-label">{c.label}</div>
            </div>
          </div>
        </div>
      </section>

      <section className="detail-body">
        <div className="container">
          <div className="detail-section">
            <div className="detail-section-label">The challenge</div>
            <h2 className="detail-section-h">What was broken</h2>
            <p>{c.challenge}</p>
          </div>

          <div className="detail-section">
            <div className="detail-section-label">The approach</div>
            <h2 className="detail-section-h">How Capexara intervened</h2>
            <ul className="detail-bullets" data-testid="case-approach">
              {c.approach.map((step, i) => <li key={i}>{step}</li>)}
            </ul>
          </div>

          <div className="detail-section">
            <div className="detail-section-label">The outcome</div>
            <h2 className="detail-section-h">What it delivered</h2>
            <div className="detail-outcome" data-testid="case-outcomes">
              {c.outcome.map((o, i) => (
                <div className="detail-outcome-card" key={i}>
                  <div className="detail-outcome-metric">{o.metric}</div>
                  <div className="detail-outcome-label">{o.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="detail-section">
            <div className="detail-section-label">Platforms used</div>
            <h2 className="detail-section-h">The stack in play</h2>
            <div className="detail-platforms">
              {relatedProducts.map((p) => (
                <Link key={p.slug} to={`/platforms/${p.slug}`} className="detail-platform-chip" data-testid={`case-platform-${p.slug}`}>
                  {p.indo}
                  <span className="detail-platform-chip-dev">{p.devnagari}</span>
                </Link>
              ))}
            </div>
          </div>

          <blockquote className="detail-quote">
            {c.quote}
            <span className="detail-quote-attrib">— {c.quoteAttrib}</span>
          </blockquote>
        </div>
      </section>

      <CtaForm />
    </>
  );
}
